<template>
	<div class="card">
	  <div class="card-main" @click="switchPanel.applicant = !switchPanel.applicant">
	    <div class="card_title">
				<span class="card_switch" >
				  <i v-if="!switchPanel.applicant" class="iconfont iconzhankai"></i>
				  <i v-else class="iconfont iconshouhui"></i>
				</span>
				{{title}}
			</div>
			<div v-if="btnData && btnData.length">
				<el-button v-for="(item, index) in btnData" :key="index" class="plr28" :type="index == 0 ? 'primary' : ''" @click="(e) => btnFun(e, item)" size="mini">{{item}}</el-button>
			</div>
	  </div>
		<div class="card_content" v-show="switchPanel.applicant">
			<slot name="content"></slot>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			title: {
				default: ''
			},
			btnData: {
				type: Array,
				default: () => []
			}
		},
		data() {
			return {
				switchPanel: {
				  applicant: true,
				},
			}
		},
		methods: {
			btnFun(e,value) {
				e.stopPropagation()
				this.$emit('boxfoldfun', value)
			}
		}
	}
</script>

<style scoped lang="scss">
.card {
	background-color: #fff;
	padding: 20px;
	.card-main {
		display: flex;
		align-items: center;
		cursor: pointer;
		.plr28 {
			margin-left: 8px;
		}
	}
	.card_title {
		font-size:16px;
		font-family:PingFangSC-Medium,PingFang SC;
		font-weight:500;
		color:rgba(51,51,51,1);
		line-height:16px;
		cursor: pointer;
	}
	.card_content {
		margin-top: 20px;
	}
}
.line_input {
	width: 1550px;
}
.card_switch {
	color: rgba(204, 204, 204, 1);
	// margin-right: 8px;
	.iconfont {
		font-size: 16px;
	}
}
.card_title:hover .card_switch{
	color: rgba(91, 140, 255, 1);
}
.card_button {
	margin-top: 20px;
	margin-right: 40px;
	margin-bottom: 0px;
}
.card_button + .input-with-col2 {
	margin-bottom: 0px;
	margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/box-with-title-fold/index.vue